module.exports = __webpack_public_path__ + "static/img/ap2.1d94e5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap2.jpg
// module id = FyH0
// module chunks = 1